module.exports = __webpack_public_path__ + "static/media/Component.d4a0d642.svg";